<template>
  <svg :width="width" :height="height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1537_10373)">
      <circle cx="25" cy="25" r="17" fill="white" />
      <path
        d="M22.2997 25C22.2997 24.8208 22.3681 24.6416 22.5047 24.5049L26.8045 20.2051C27.0781 19.9316 27.5215 19.9316 27.7949 20.2051C28.0684 20.4786 28.0684 20.9219 27.7949 21.1955L23.9902 25L27.7948 28.8045C28.0682 29.078 28.0682 29.5213 27.7948 29.7947C27.5214 30.0684 27.0779 30.0684 26.8044 29.7947L22.5046 25.495C22.368 25.3583 22.2997 25.1791 22.2997 25Z"
        fill="#006EFF"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_1537_10373"
        x="0"
        y="0"
        width="50"
        height="50"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0.431373 0 0 0 0 1 0 0 0 0.5 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1537_10373" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_1537_10373"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {
 props:{
  height:{
   default:50
  },
  width:{
   default:50
  }
 }
};
</script>

<style></style>
